"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const mui_1 = require("tss-react/mui");
const core_1 = require("companion-app-components/utils/core");
const ValueField_1 = __importDefault(require("../ValueField"));
const styles_1 = __importDefault(require("../styles"));
const log = (0, core_1.getLogger)('containers/OverviewPage/components/TopHoldings/HoldingRow/index.js');
log.log('loaded');
const FlexWrapper = (0, styled_components_1.default)('div') `
  display: flex;
  justify-content: space-between;
  height: 16px;
`;
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const HoldingRow = (props) => {
    const { holding, isByHoldingList } = props;
    const { classes } = useStyles();
    let amountDelta;
    let quoteChangePercentage;
    let value;
    if (holding) {
        if (isByHoldingList) {
            amountDelta = holding.amountDelta;
            value = holding.numberOfShares * holding.security.latestPrice;
            if (holding.amount - amountDelta) {
                quoteChangePercentage = ((amountDelta / (holding.amount - amountDelta)) * 100);
            }
            else {
                quoteChangePercentage = 'N/A';
            }
        }
        else {
            amountDelta = holding.security.quoteChange;
            value = holding.security.latestPrice;
            quoteChangePercentage = holding.security.quoteChangePercentage;
        }
    }
    return (<div style={{ width: '100%' }}>
      {holding &&
            <>
          <FlexWrapper>
            <Typography_1.default variant="body2" className={classes.companyName}>
              {holding.companyName}
            </Typography_1.default>

            <ValueField_1.default inputValue={value} style={{ marginLeft: 5 }}/>

          </FlexWrapper>
          <FlexWrapper>

            <Typography_1.default variant="caption" className={classes.tickerSymbol}>
              {holding.tickerSymbol}
            </Typography_1.default>

            <div>
              <ValueField_1.default inputValue={amountDelta} color="sign"/>
              &nbsp;
              <ValueField_1.default inputValue={quoteChangePercentage} color="sign" type="percentage" useParentheses/>

            </div>
          </FlexWrapper>
        </>}
    </div>);
};
exports.default = HoldingRow;
